var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
// import { StateService } from '@uirouter/angular';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './../../../services/auth.service';
import { UserService } from './../../../services/user.service';
import { CommonFunctionService } from './../../../services/common-function.service';
import { AppSettings } from './../../../app.settings';
import { AdminService } from 'app/services/admin.service';
import { LayerService } from 'app/services/layer.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(router, toastr, adminService, authService, userService, commonFuncService, layerService
    // private esService: ElasticsearchService
    ) {
        this.router = router;
        this.toastr = toastr;
        this.adminService = adminService;
        this.authService = authService;
        this.userService = userService;
        this.commonFuncService = commonFuncService;
        this.layerService = layerService;
        this.imgUrl = AppSettings.authLogoUrl;
        this.registerUrl = AppSettings.lbRegisterUrl;
        this.pwResetUrl = AppSettings.lbPwResetUrl;
        this.isLoggingin = false;
    }
    LoginComponent.prototype.login = function () {
        var _this = this;
        if (!this.password) {
            this.toastr.error('Please enter a password.');
            return;
        }
        // Test: es
        // this.esService.addToIndex({
        // 	index: 'index',
        // 	type: 'login',
        // 	id: uuid(),
        // 	body: {
        // 		test: 123
        // 	}
        // }).then(res => {
        // 	console.log('added success', res);
        // }, err => {
        // 	console.log('err', err);
        // });
        //
        this.commonFuncService.setLoadingSpinner(true);
        this.authService.login(this.email, this.password, function (res) { return __awaiter(_this, void 0, void 0, function () {
            var err_1, layers, url, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        // update token
                        return [4 /*yield*/, this.userService.setUpdatedToken(res.data.content)];
                    case 1:
                        // update token
                        _a.sent();
                        // const usbList = await this.adminService.getUserSubscription(this.email, 'A3I');
                        // if (usbList && usbList[0] ) {
                        // 	await this.userService.generateApiKey(this.password, usbList[0].userSubId);
                        // }
                        return [4 /*yield*/, this.userService.generateApiKey(this.password, this.userService.getUserInfo().userSubId)];
                    case 2:
                        // const usbList = await this.adminService.getUserSubscription(this.email, 'A3I');
                        // if (usbList && usbList[0] ) {
                        // 	await this.userService.generateApiKey(this.password, usbList[0].userSubId);
                        // }
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.layerService.getLayers()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        layers = this.layerService.layerListBS.getValue();
                        url = (layers.layers && layers.layers.find(function (l) { return l.id; })) ? '/azgiv/layers/live-layers' : '/azgiv/dashboard';
                        this.router.navigateByUrl(url, {
                            queryParamsHandling: 'preserve'
                        }).then(function () {
                        });
                        return [3 /*break*/, 8];
                    case 7:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 8];
                    case 8:
                        //
                        this.isLoggingin = false;
                        this.commonFuncService.setLoadingSpinner(false);
                        return [2 /*return*/];
                }
            });
        }); }, function (err) {
            _this.isLoggingin = false;
            _this.commonFuncService.setLoadingSpinner(false);
        });
    };
    LoginComponent.prototype.test = function () {
        this.authService.test();
    };
    // login() {
    // 	this.commonFuncService.setLoadingSpinner(true);
    // 	this.authService.login(this.email, // sarah.hess@gisticinc.com
    // 		(res) => {
    // 			// update token
    // 			this.userService.setUpdatedToken(res.data.content);
    // 			// check user subscription
    // 			this.adminService.getUserSubscription(this.email,
    // 				(rsp) => {
    // 					this.isLoggingin = false;
    // 					this.commonFuncService.setLoadingSpinner(false);
    // 					// user has subscription. allow loging in.
    // 					if (rsp.data && rsp.data[0]) {
    // 						this.userService.setHasUserSubscription(true);
    // 						// Get previous state path
    // 						const prevStateInfo = sessionStorage.getItem('prevState') ? JSON.parse(sessionStorage.getItem('prevState')) : null;
    // 						// Default path '/azgiv'
    // 						const path = prevStateInfo ? prevStateInfo.path : '/azgiv';
    // 						const params = prevStateInfo ? prevStateInfo.params : {};
    // 						this.router.navigate([path, params]);
    // 						// const toState = prevStateInfo ? prevStateInfo.name : 'azgiv';
    // 						// const params = prevStateInfo ? prevStateInfo.params : {};
    // 						// this.stateService.go(toState, params).then(() => {
    // 						// });
    // 					} else { // user has not subscription.
    // 						this.userService.setHasUserSubscription(false);
    // 						console.log('NO USER SUBSCRIPTION.');
    // 						this.toastr.error('No user subscription.');
    // 					}
    // 				}, (err) => {
    // 					this.isLoggingin = false;
    // 					this.commonFuncService.setLoadingSpinner(false);
    // 				});
    // 		}, (err) => {
    // 			this.isLoggingin = false;
    // 			this.commonFuncService.setLoadingSpinner(false);
    // 		});
    // }
    LoginComponent.prototype.ngOnInit = function () {
    };
    return LoginComponent;
}());
export { LoginComponent };
